export const identityProviders = [
  "windows",
  "entraId",
  "ping",
  "pingFederate",
  "pingOne",
  "okta",

  "office365", // legacy
  "windowsIntegrated", // legacy
] as const;

export type AuthMode = (typeof identityProviders)[number] | undefined;
